import React, { useState } from "react";
import Exam from "./Exam"
import Clienthomemenu from "../Menus/Clienthomemenu";

const JoinTest = () => {
  const [testCode, setTestCode] = useState("");
  const [startExam, setStartExam] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [testid,setTestid]=useState("");
  const user = JSON.parse(localStorage.getItem("user"));  
  const uid = user?.UID;
  
  const handleJoinTest = () => {
    if (!testCode) {
      alert("Please enter Test Code");
      return;
    }

    setLoading(true);

    const now = new Date();

    const payload = {
      TEST_CODE: testCode,
      UID: uid, // login mathi
      CUR_DATE: now.toISOString().split("T")[0],
      CUR_TIME: now.toTimeString().slice(0, 5),
    };

    const path1 = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_JOIN_TEST}`;

    fetch(path1, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.res === "success") {
          setQuestions(data.data);
          setTestid(data.TEST_UID); // 👈 questions
          setStartExam(true);      // 👈 EXAM START
        } else {
          alert(data.msg || "Invalid Test Code");
        }
        setLoading(false);
      })
      .catch(() => {
        alert("Server error");
        setLoading(false);
      });
  };

  if (startExam) {
    return <Exam questions={questions}  testid={testid} userid={uid}/>;
  }

  return (
    <>
     <Clienthomemenu title="EasyITI" testhistory="testhistory"/>
    <div
  className="container"
  style={{
    paddingTop: "90px",
  }}
>
      <h3>Enter Test Code</h3>

      <input
        type="number"
        className="form-control mb-2"
        placeholder="Enter Test Code"
        value={testCode}
        onChange={(e) => setTestCode(e.target.value)}
      />

      <button
        className="btn btn-primary mt-3"
        onClick={handleJoinTest}
        disabled={loading}
      >
        {loading ? "Joining..." : "Join Test"}
      </button>
    </div>
    </>
  );
};

export default JoinTest;
